import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20h16l-8 -16z","key":"svg-0"}]]

const IconDelta = createReactComponent('outline', 'delta', 'Delta', __iconNode);

export default IconDelta;